module.exports = __webpack_public_path__ + "img/logo2.79b8883e.png";